
import React, { Component } from 'react';

class App extends Component {
  render() {
    return (
      <div style={{ flex: 1, margin: 20 }}>
        <h1>Hello</h1>
        <div style={{ marginLeft: 20 }}>
          <li><a href="/mh_policy">Mental health policy</a></li>
          <li><a href="/pedubon_policy">PEDUbon policy</a></li>
          <li><a href="/import_data">Import_data</a></li>
          <li><a href="/surwey_area">แบบประเมินบริบทพื้นที่</a></li>
          <li><a href="/moj_go_th">MOJ.GO.TH</a></li>
          <li><a href="/moj_go_th2">MOJ.GO.TH2</a></li>
          <li><a href="/moj_go_th3">MOJ.GO.TH3</a></li>
          <li><a href="/result">MOJ.Result</a></li>
          <li><a href="/ssr">ssr</a></li>
          <li><a href="/ssr_result">ssr.Result</a></li>
          <li><a href="/sc">คอรัปชั่น</a></li>
          <li><a href="/scResult">sc.Result</a></li>
          <li><a href="/test">test</a></li>
          {/* <li><a href="/adminEdit"></a></li> */}
        </div>
      </div>
    )
  }
}
export default App;
